import React from 'react';
import { Box, Checkbox } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const logisticsCategoryRenderOption = (
  autoCompleteProps,
  option,
  { selected }
) => {
  const icon = (
    <CheckBoxOutlineBlankIcon
      data-testid="CheckBoxOutlineBlankIcon"
      fontSize="small"
    />
  );
  const checkedIcon = (
    <CheckBoxIcon data-testid="CheckBoxIcon" fontSize="small" />
  );

  return (
    <Box
      component="li"
      {...autoCompleteProps}
      key={option.value}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '2px 6px',
        cursor: 'pointer',
        transition: 'background-color 0.15s',
        backgroundColor: 'transparent',
        borderRadius: '6px',
        marginBottom: '0',
        fontSize: '14px',
        margin: '5px 0',
        fontWeight: 400,
        color: (theme) => theme.palette.text.primary,
        '&:hover': {
          backgroundColor: (theme) =>
            `${theme.palette.grays?.gray100} !important`,
        },
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          color: (theme) => theme.palette.text.primary,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.grays?.gray100,
          },
        },
        '&.Mui-focusVisible': {
          backgroundColor: (theme) => theme.palette.grays?.gray100,
        },
      }}
    >
      <Checkbox
        key={`checkbox-${option.value}`}
        size="small"
        icon={icon}
        checkedIcon={checkedIcon}
        sx={{
          padding: 0,
          '& .MuiSvgIcon-root': {
            fontSize: '16px',
          },
        }}
        checked={selected}
      />
      <Box
        sx={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: option.color,
        }}
      />
      {option.text || ''}
    </Box>
  );
};

export { logisticsCategoryRenderOption };
